import {
  TFetchApplicationLogsByRequestIdParams,
  thirdPartyLogsApi,
  TListApplicationLogsByPartnerIdParams,
} from 'onboarding/api/thirdPartyLogsApi'

export class ThirdPartyLogService {
  public fetchApplicationsByRequestId(requestId: number) {
    return thirdPartyLogsApi.fetchApplicationsByRequestId(requestId)
  }

  public fetchApplicationsByPartnerId(partnerId: string) {
    return thirdPartyLogsApi.fetchApplicationsByPartnerId(partnerId)
  }

  public getCrudApplicationLogsByRequestId(params: TFetchApplicationLogsByRequestIdParams) {
    return thirdPartyLogsApi.getCrudApplicationLogsByRequestId(params)
  }

  public getCrudApplicationLogsByPartnerId(params: TListApplicationLogsByPartnerIdParams) {
    return thirdPartyLogsApi.getCrudApplicationLogsByPartnerId(params)
  }
}

export const thirdPartyLogService = new ThirdPartyLogService()
